import { CategoryMapping } from './mapping.js';
import { PlayerErrorSeverity, PlayerErrorCategory, PlayerErrorCode } from './types.js';
import { hasStack, formatError, nativeErrorToJSON } from './utils.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const _PlayerError = class _PlayerError extends Error {
  constructor({
    severity,
    code,
    playerCode,
    data,
    originalError
  }) {
    super();
    __publicField(this, "isPlayerError", true);
    __publicField(this, "severity");
    __publicField(this, "category");
    __publicField(this, "code");
    __publicField(this, "playerCode");
    __publicField(this, "data");
    this.name = "PlayerError";
    this.severity = severity;
    this.category = _PlayerError.findCategory(code);
    this.code = code;
    this.cause = hasStack(originalError) ? formatError(originalError) : originalError;
    this.data = data;
    this.playerCode = playerCode;
    this.message = this.toString();
    if (!this.stack) {
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
      } else {
        try {
          throw new Error("Stack generator");
        } catch (error) {
          this.stack = error.stack;
        }
      }
    }
  }
  toString() {
    return `${this.category}: ${this.code} (${this.playerCode})`;
  }
  toJSON() {
    return {
      severity: this.severity,
      category: this.category,
      code: this.code,
      data: {
        ...this.data,
        originalError: this.data?.originalError instanceof Error ? nativeErrorToJSON(this.data.originalError) : this.data?.originalError
      },
      playerCode: this.playerCode,
      stack: this.stack,
      cause: this.cause
    };
  }
  static create({
    severity,
    code,
    playerCode,
    data,
    originalError
  }) {
    if (originalError && typeof originalError === "object") {
      const cached = _PlayerError.cache.get(originalError);
      if (cached)
        return cached;
    }
    const playerError = new _PlayerError({
      severity,
      code,
      playerCode,
      data,
      originalError
    });
    if (originalError && typeof originalError === "object")
      _PlayerError.cache.set(originalError, playerError);
    return playerError;
  }
  static findCategory(code) {
    return Object.keys(CategoryMapping).find((category) => CategoryMapping[category].includes(code)) || this.Category.OTHER;
  }
};
__publicField(_PlayerError, "cache", /* @__PURE__ */ new WeakMap());
__publicField(_PlayerError, "Severity", PlayerErrorSeverity);
__publicField(_PlayerError, "Category", PlayerErrorCategory);
__publicField(_PlayerError, "Code", PlayerErrorCode);
let PlayerError = _PlayerError;

export { PlayerError };
//# sourceMappingURL=PlayerError.js.map
